<div data-testid="login-container" class="p-2 flex justify-center">
  <p-card data-testid="login-card" styleClass="shadow-2 rounded-lg  mb-4 w-full sm:w-96 md:w-96">
    <div data-testid="login-form-wrapper" class="p-2">
      <form data-testid="login-form" [formGroup]="form" (submit)="login()">
        <div data-testid="login-header" class="border-b border-gray mb-3">
          <div data-testid="login-title-wrapper" class="pb-2">
            <span data-testid="login-title" class="text-xl text-primary font-light mb-3 pb-3">{{
              'Login to OffConOn Admin' | translate
            }}</span>
          </div>
        </div>

        <div data-testid="login-email-field" class="mb-6">
          <label data-testid="login-email-label" for="email" class="block font-bold mb-2">{{
            'Email' | translate
          }}</label>
          <input
            data-testid="login-email-input"
            id="email"
            formControlName="email"
            type="text"
            pInputText
            class="w-full p-3" />

          <offconon-shared-ui-form-errors
            data-testid="login-email-errors"
            [ctrl]="form.get('email')" />
        </div>
        <div data-testid="login-password-field" class="mb-6">
          <label data-testid="login-password-label" for="password" class="block font-bold mb-2">{{
            'Password' | translate
          }}</label>
          <p-password
            #password
            data-testid="login-password-input"
            id="password"
            styleClass="p-password p-component p-inputwrapper p-input-icon-right w-full rounded-lg  mb-2"
            formControlName="password"
            [feedback]="false"
            [toggleMask]="true"
            [inputStyle]="{ width: '100%' }" />
          <small
            data-testid="login-reset-password-link"
            class="block cursor-pointer"
            (click)="createResetPassword()">
            {{ 'If you have forgotten your password, you can reset it.' | translate }}
            <span data-testid="login-reset-password-text" class="text-blue-500">{{
              'Click here' | translate
            }}</span>
          </small>
        </div>

        <div data-testid="login-button-wrapper" class="flex justify-end flex-wrap">
          <button
            data-testid="login-submit-button"
            id="login-submit-button"
            type="submit"
            pButton
            icon="pi pi-arrow-right"
            iconPos="right"
            class=""
            [disabled]="form.invalid"
            label="{{ 'Login' | translate }}"
            [loading]="loading"></button>
        </div>
      </form>
    </div>
  </p-card>
</div>
